import { Flex, Separator, VStack } from "@chakra-ui/react";
import { observer } from "mobx-react";
import { OsaNodeDetail } from "./node/OsaNodeDetail";
import { OsaWayDetail } from "./osaway/OsaWayDetail";
import { ProjectDetail } from "./project/ProjectDetail";
import { useStores } from "../../../../shared/stores/RootStore";
import useAutoResizeMap from "../../../../hooks/useAutoResizeMap";
import { LifeCycleStage } from "../../../../osaway/models/LifeCycleStage";
import { HlaWayDetail } from "../../../../hla/views/HlaWayDetail/HlaWayDetail";
import { MapQueryControls } from "../hla-query/MapQueryControls";

const DetailBarBase: React.FC = () => {
  useAutoResizeMap();
  const { osaNodeStore, osaWayStore, hlaStore, mapQueryStore } = useStores();
  const selectedOsaWay = osaWayStore.getSelected();

  if (mapQueryStore.active) {
    return <MapQueryControls />;
  }

  if (osaNodeStore.getSelected()) {
    return (
      <Flex
        flexShrink={0}
        flexDirection="column"
        w={selectedOsaWay?.lifeCycleStage === LifeCycleStage.Review ? 540 : 320}
      >
        <OsaNodeDetail />
      </Flex>
    );
  }
  if (selectedOsaWay) {
    return (
      <Flex
        flexShrink={0}
        flexDirection="column"
        w={selectedOsaWay.lifeCycleStage === LifeCycleStage.Review ? 540 : 320}
      >
        <OsaWayDetail />
      </Flex>
    );
  }
  if (hlaStore.getSelected()) {
    return (
      <VStack
        width={"50%"}
        separator={<Separator orientation={"horizontal"} w="full" />}
      >
        <HlaWayDetail />
      </VStack>
    );
  }
  return (
    <Flex flexShrink={0} flexDirection="column" w={320}>
      <ProjectDetail />
    </Flex>
  );
};

export const DetailBar = observer(DetailBarBase);
